import { connect } from 'react-redux';
import {
  compose,
  withHandlers,
  mapProps,
  withProps,
  lifecycle,
} from 'recompose';
import omit from 'lodash/omit';
import ServicesWrapperContainer from './ServicesWrapper';
import * as actions from '../actions';
import { getRoleIdType, getShopBrandId } from '../../../auth/selectors';
import { withActionByRole } from '../../../common/helpers/actions';
import {
  CustomerIoTracker,
  SERVICE_CREATION_COMPLETED,
  SERVICE_CREATION_STARTED,
} from '../../../../modules/infra/observability/customer-io';

const mapStateToProps = (state, props) => ({
  roleIdType: getRoleIdType(state),
  brandId: getShopBrandId(state),
});

const enhance = compose(
  connect(mapStateToProps),
  withActionByRole(
    'addService', actions.addService, actions.addBarberUserService, actions.addBrandUserService,
  ),
  withActionByRole(
    'updateService', actions.updateService, actions.updateBarberUserService, actions.updateBrandUserService,
  ),
  withActionByRole(
    'deleteService', actions.deleteService, actions.deleteBarberService, actions.deleteBrandService,
  ),
  withHandlers({
    saveService: props => data => {
      if (props.params.serviceId) {
        return props.updateService(props.params.serviceId, data);
      } else {
        return props.addService(data).then((service) => {
          CustomerIoTracker.getInstance().track(SERVICE_CREATION_COMPLETED);
          return service;
        });
      }
    },
    deleteService: props => () => props.deleteService(props.params.serviceId),
  }),
  withProps((ownProps) => {
    if (ownProps.roleIdType.type === 'brand') {
      return { redirectUrl: '/brand/services' };
    }

    return { redirectUrl: ownProps.roleIdType.type === 'shop' ? '/services' : '/barber/services' };
  }),
  mapProps((props) => {
    if (!props.params.serviceId) {
      return omit(props, ['deleteService']);
    }

    return props;
  }),
  lifecycle({
    componentDidMount() {
      if (!this.props.params.serviceId) {
        CustomerIoTracker.getInstance().track(SERVICE_CREATION_STARTED);
      }
    },
  })
);

export default enhance(ServicesWrapperContainer);
